module.exports = __webpack_public_path__ + "img/report-3.1c9e5623.jpg";